/**
 * Canonical account id for joining movement rollups ↔ impacted_clients.
 * Prefer API strings so leading zeros (e.g. "004953005") are preserved.
 */
export function normalizeOpportunityAccountId(raw: unknown): string {
    if (raw === undefined || raw === null) return ""
    if (typeof raw === "number" && Number.isFinite(raw)) {
        return String(Math.trunc(raw))
    }
    return String(raw).trim()
}

/** Uppercase trimmed key for optional display-name fallback when account keys differ. */
export function normalizePortfolioClientNameKey(raw: unknown): string {
    if (raw === undefined || raw === null) return ""
    return String(raw).trim().toLocaleUpperCase("pt-BR")
}

export function normalizeAdvisorDisplayName(raw: unknown): string | undefined {
    if (raw === undefined || raw === null) return undefined
    const s = String(raw).trim()
    return s || undefined
}
